export { default } from './Dots'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Dots/Dots/index.js